export const Departments = [
  { value: 0, label: 'Клиентский отдел' },
  { value: 1, label: 'Коммерческий отдел' },
  { value: 2, label: 'Отдел кадров' },
];
